module.exports = __webpack_public_path__ + "img/Anya_O_27.7a1d4122.jpg";